<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div style="clear: both">
      <div v-if="podatkiOsim !== null" style="padding-top: 40px">
        <el-form class="sim-podatki" label-width="130px" :label-position="formaOrientacija">
          <p class="open-sans-20pt pb-3">
            Podatki o SIM
          </p>
          <el-form-item label="UMTS številka:" class="visina-vrstice">
            <b>
              {{ VrniFormatiranoTelefonsko(podatkiOsim.stevilka, '5') }}
            </b>
          </el-form-item>
          <el-form-item label="Serijska številka:" class="visina-vrstice">
            <b>
              {{ podatkiOsim.serijska }}
            </b>
          </el-form-item>
          <el-form-item label="PIN:" class="visina-vrstice">
            <b>
              {{ podatkiOsim.pin }}
            </b>
          </el-form-item>
          <el-form-item label="PUK:" class="visina-vrstice">
            <b>
              {{ podatkiOsim.puk }}
            </b>
          </el-form-item>
        </el-form>
        <div style="padding-top: 20px; padding-bottom: 30px">
          <hr class="hr-stil"/>
        </div>
      </div>
      <div>
        <p class="open-sans-20pt">
          Nastavitve SIM
        </p>
        <el-form label-width="315px" :label-position="formaOrientacija" class="mt-6 nastavitve-sim">
          <el-form-item :label="prenosniPodatkiMoznostSMSDeblokade.name">
            <el-radio-group v-model="prenosniPodatkiMoznostSMSDeblokade.status"
                            @change="SpremebaSmSDeblokade(prenosniPodatkiMoznostSMSDeblokade.status)">
              <el-radio label="off" class="odmik-desno">
                Izključeno
              </el-radio>
              <el-radio label="on">
                Vključeno
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Obveščanje o informacijah v gostovanju" label-width="315px">
            <el-radio-group v-model="privzetaVrednost.idUmtsGostovanjeObvescanje"
                            @change="SprmemebaInformativnoObvescanjeTujina">
              <el-radio :label="1"  class="odmik-desno">
                Ne obveščaj
              </el-radio>
              <el-radio :label="2">
                Obveščaj s SMS sporočilom
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="dodatneMobilneStoritve !== []"
            v-for="storitev in dodatneMobilneStoritve"
            :key="storitev.id"
            :label="storitev.title">
            <el-radio-group
              v-model="storitev.vklopljeno"
              @change="OpozoriloPredSprememboStoritve(storitev)">
              <el-radio :label="false" class="odmik-desno">
                Izključeno
              </el-radio>
              <el-radio :label="true">
                Vključeno
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="pt-8">
            <span style="color: #080809;">
              <el-icon class="el-icon-info" style="font-size: 16px">
              </el-icon>
              <span style="padding-left: 4px" class="navadno-besedilo">
                Vklop deblokade prek SMS omogoča, da po blokadi ponovno omogočite prenos
                podatkov s preprostim SMS sporočilom.
                Za vklop blokade pošljite SMS s ključno besedo
                <b>
                  BLOKADA PODATKOV TUJINA
                </b>
                na številko 1111. Za deblokado pošljite SMS s ključno besedo
                <b>
                  DEBLOKADA PODATKOV TUJINA
                </b>
                na isto številko.
                <b>
                  VoWiFi
                </b>
                (Voice over WiFi) omogoča klicanje prek WiFi omrežja, kar je
                uporabno tam, kjer je mobilni signal šibek (npr. v stavbah).
                <b>
                  VoLTE
                </b>
                (Voice over LTE) omogoča klicanje prek 4G/LTE omrežja, kar pomeni
                hitrejšo vzpostavitev klica, boljšo kakovost zvoka in možnost hkratnega prenosa podatkov med klicem.
                Več informacij o VoLTE in VoWiFi najdete na:
                <a href="https://www.t-2.net/navodila-za-vklop-uporabo-volte-vowifi"
                   target="_blank" style="cursor: pointer;"
                   class="primarna-barva">
                  https://www.t-2.net/navodila-za-vklop-uporabo-volte-vowifi</a>.
              </span>
            </span>
        </div>
      </div>
      <div style="padding-top: 20px; padding-bottom: 25px">
        <hr class="hr-stil"/>
      </div>
      <div>
        <p class="open-sans-20pt">
          Začasna blokada SIM kartice
        </p>
        <div style="padding-bottom: 20px; padding-top: 30px">
          <p class="navadno-besedilo">
            Začasna blokada SIM kartice pomeni, da se v vse storitve v omrežju začasno prekinejo,
            obračunavanje naročnine pa teče dalje. Začasno blokado lahko uporabite v primeru izgube
            SIM kartice. Po 24 urah se bo SIM kartica ponovno aktivirala. Za aktivacijo nove SIM kartice obiščite T-2
            poslovalnico, ki vam bo izdala novo SIM kartico.
          </p>
        </div>
        <div class="postavitev-gumba-blokiranja" v-if="statusDeaktivacije === false">
          <a class="okvir-zacasno-blokiraj open-sans-13pt" @click="ZacasnaBlokadaSimKartice">
            <img class="velikost-ikone-dekativacija"
                 src="/static/img/Icon/NastavitveTelefonija/Icon-awesome-lock.png">
            <span style="padding-left: 5px">
              ZAČASNO BLOKIRAJ
            </span>
          </a>
        </div>
        <div class="postavitev-gumba-blokiranja" v-else>
          <a class="okvir-zacasno-blokiraj open-sans-13pt" @click="AktivacijaSimKartice">
            <img class="velikost-ikone-dekativacija"
                 src="/static/img/Icon/NastavitveTelefonija/Icon-awesome-lock.png">
            <span style="padding-left: 5px">
              AKTIVIRAJ
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Checkbox, Button, Select, Option, Input, Loading, CollapseItem, Collapse, Tooltip, Radio,
  RadioGroup, MessageBox
} from 'element-ui'
import ClientAgent from '../../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {
  FormatirajTelefonskoStevilko
} from '../../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke'
import {StoritevEnum} from '../../../../../../assets/js/Enum/StoritevEnum'

export default {
  name: 'PodatkiSim',
  mixins: [PrikazVsebine, FormatirajTelefonskoStevilko],
  data () {
    return {
      formaOrientacija: 'left',
      mejnaSirina: 770,
      clientAgent: null,
      statusDeaktivacije: false,
      dodatneMobilneStoritve: []
    }
  },
  watch: {
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    prenosniPodatkiUmtsObvescanje: {
      deep: true,
      handler (val) {
        if ([1, 2].includes(val)) {
          this.privzetaVrednost.idUmtsGostovanjeObvescanje = val
        }
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.PridobiMoznostSMSDeblokade()
    this.PridobiDodatneMobilneStoritve()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  props: {
    prenosniPodatkiMoznostSMSDeblokade: null,
    prenosniPodatkiUmtsObvescanje: null,
    podatkiOsim: null,
    privzetaVrednost: null,
    izbranPrikljucek: null,
    izbranaTelefonska: null
  },
  components: {
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Input.name]: Input,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [MessageBox.name]: MessageBox
  },
  methods: {
    PridobiMoznostSMSDeblokade () {
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/umts/sim/simInfo',
          param,
          null,
          'SetPridobiMoznostSMSDeblokade',
          'ErrPridobiMoznostSMSDeblokade')
      }
    },
    PridobiDodatneMobilneStoritve () {
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/umts/getAdditionalMobileServices',
          param,
          null,
          'SetDodatneMobilneStoritve',
          'ErrDodatneMobilneStoritve')
      }
    },
    SetDodatneMobilneStoritve (podatki) {
      if (podatki.services !== undefined && Array.isArray(podatki.services)) {
        this.dodatneMobilneStoritve = podatki.services.reverse()
        this.dodatneMobilneStoritve.forEach(storitev => {
          if (storitev.id === StoritevEnum.STORITEV_VOLTE) storitev.title = 'Mobilna storitev VoLTE in VoWifi'
          if (storitev.id === StoritevEnum.STORITEV_5G) storitev.title = '5G omrežje'
          storitev['vklopljeno'] = storitev.quantity === 1
        })
      }
    },
    ErrDodatneMobilneStoritve (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SetPridobiMoznostSMSDeblokade (podatki) {
      this.statusDeaktivacije = false
      this.statusDeaktivacije = podatki.data.zacasnoDeaktivirana
    },
    ErrPridobiMoznostSMSDeblokade (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SpremebaSmSDeblokade (spremembaStatusSmSDeblokada) {
      this.$emit('spremebaSmSDeblokade', spremembaStatusSmSDeblokada)
    },
    SprmemebaInformativnoObvescanjeTujina () {
      this.$emit('spremembaObvescanjeTujina', this.privzetaVrednost.idUmtsGostovanjeObvescanje)
    },
    ZacasnaBlokadaSimKartice () {
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        MessageBox.confirm(
          'Ali ste prepričani, da želite začasno blokirati SIM kartico?', {
            confirmButtonText: 'Da, želim začasno blokirati SIM',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            cancelButtonText: 'Prekliči',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          let param = ['idPrikljucek=' + this.izbranPrikljucek]
          param.push('stevilka=' + this.izbranaTelefonska)
          this.clientAgent.postWsRequest(this,
            'prikljucek/telefonija/umts/sim/deaktivirajSim?',
            param,
            null,
            'SetNastaviMoznostDeblokadeSMS',
            'ErrNastaviMoznostDeblokadeSMS')
        }).catch((err) => {
          err = null
        })
      }
    },
    OpozoriloPredSprememboStoritve (storitev) {
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        let statusText = storitev.vklopljeno ? 'vklopiti' : 'izklopiti'
        MessageBox.confirm(
          `Ali ste prepričani, da želite ${statusText} ${storitev.title}?`, {
            confirmButtonText: 'Da želim ' + statusText,
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            cancelButtonText: 'Prekliči',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          this.SetStatusStoritve(storitev)
        }).catch((err) => {
          err = null
          storitev.vklopljeno = !storitev.vklopljeno
        })
      }
    },
    async SetStatusStoritve (storitev) {
      let params = {
        idPrikljucek: this.izbranPrikljucek,
        stevilka: this.izbranaTelefonska,
        serviceId: storitev.id,
        statusId: 1,
        removeService: !storitev.vklopljeno
      }
      try {
        await this.clientAgent.makeRequest(
          'prikljucek/telefonija/umts/setAdditionalMobileService',
          params,
          'POST'
        )
        this.SetStatusStoritveObvestilo(storitev.title)
      } catch (e) {
        this.ErrStatusStoritveObvestilo(storitev.title)
      }
      this.PridobiDodatneMobilneStoritve()
    },
    ErrStatusStoritveObvestilo (naziv) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Storitev ' + naziv + ' ni bila posodobljena.'
      this.ShowErrorMessage(paramObvestilo)
    },
    SetStatusStoritveObvestilo (naziv) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Storitev ' + naziv + ' je bila posodobljena.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    SetNastaviMoznostDeblokadeSMS () {
      this.PridobiMoznostSMSDeblokade()
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljena blokada SIM kartice.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrNastaviMoznostDeblokadeSMS (podatki) {
      this.ShowWarningMessage(podatki)
    },
    AktivacijaSimKartice () {
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        MessageBox.confirm(
          'Ali ste prepričani, da želite aktivirati SIM kartico?', {
            confirmButtonText: 'Da',
            cancelButtonText: 'Prekliči',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          let param = ['idPrikljucek=' + this.izbranPrikljucek]
          param.push('stevilka=' + this.izbranaTelefonska)
          this.clientAgent.postWsRequest(this,
            'prikljucek/telefonija/umts/sim/aktivirajSim',
            param,
            null,
            'SetNastaviMoznostDeblokadeSMS',
            'ErrAktivacijaSimKartice')
        }).catch((err) => {
          err = null
        })
      }
    },
    ErrAktivacijaSimKartice (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveMobilnaTelefonija/PodatkiOsim.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/PodatkiSim.vue